<template>
  <div>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <card-header titulo="Avaliações Periódicas de Desempenho" />
                <div>
                  <div
                    class="alert alert-danger"
                    role="alert"
                    style="text-align: center"
                    v-show="mostraMensagemDeSemAvaliacao"
                  >
                    <i class="fa fa-exclamation-circle fa-lg"></i>
                    &nbsp; Caso não veja sua avaliação do ano de
                    {{ anoDaAvaliacaoAtual }}, favor entrar em contato com o
                    telefone 3213-7166 (DEGEPAT).
                  </div>
                  <table-loader :carregando="carregando">
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-if="anosAvaliados.length == 0"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Ainda não foram
                      geradas avaliações para o seu registro.
                    </div>
                    <table class="table table-striped table-hover" v-else>
                      <thead>
                        <tr>
                          <th>Ano da Avaliação</th>
                          <th v-if="ehAvaliador">Minha Avaliação</th>
                          <th v-else>Avaliação</th>
                          <th v-if="ehAvaliador" class="hidden-xs">
                            Avaliados Pendentes
                          </th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="avaliacao in avaliacoesOrdenadas"
                          :key="avaliacao.id"
                          :class="statusDaLinhaDaTabela(avaliacao)"
                        >
                          <td>{{ avaliacao.ano }}</td>
                          <td>
                            {{ statusDaAvaliacao(avaliacao) }}
                          </td>
                          <td v-if="ehAvaliador" class="hidden-xs">
                            {{ quantidadeDeAvaliacoesPorAvaliador(avaliacao) }}
                          </td>
                          <td class="td-btns td-btns-alone">
                            <div v-if="ehAvaliador">
                              <botao
                                :estilo="statusDoBotao(avaliacao)"
                                icone="editar-tabela"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  condicionalDoBotaoDeAvaliador(avaliacao)
                                "
                                v-tooltip.left="'Editar'"
                              ></botao>
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="visualizar"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  !condicionalDoBotaoDeAvaliador(avaliacao)
                                "
                                v-tooltip.left="'Visualizar'"
                              ></botao>
                            </div>
                            <div v-else>
                              <botao
                                :estilo="statusDoBotao(avaliacao)"
                                icone="editar-tabela"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  condicionalDoBotaoComum(avaliacao, true)
                                "
                                v-tooltip.left="'Editar'"
                              ></botao>
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="visualizar"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  condicionalDoBotaoComum(avaliacao, false)
                                "
                                v-tooltip.left="'Visualizar'"
                              ></botao>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </table-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import CardHeader from '@/components/card-header';
import TableLoader from '@/components/table-loader';
import AvaliacoesService from '@/services/avaliacoesService';
import AvaliadorService from '@/services/avaliadorService';
import PeriodosService from '@/services/periodosService';
import PeriodoAtualHelper from '@/helpers/PeriodoAtualHelper';
import ErrorHelper from '@/helpers/ErrorHelper';

export default {
  name: 'Avaliacao',

  data() {
    return {
      apiErrors: null,
      funcionario: this.$store.state.funcionario,
      carregando: false,
      anosAvaliados: [],
      periodos: [],
      anos: [],
      periodoAvaliacaoAnoAtual: {},
      avaliacaoAtualDoAvaliado: {},
      avaliador: {},
    };
  },
  computed: {
    anoDaAvaliacaoAtual() {
      return new Date().getFullYear() - 1;
    },
    avaliacoesOrdenadas() {
      return this.anosAvaliados.sort((a, b) => b.ano - a.ano);
    },
    mostraMensagemDeSemAvaliacao() {
      return (
        !this.anosAvaliados.some(
          competencia => competencia.ano === this.anoDaAvaliacaoAtual,
        ) &&
        this.anosAvaliados.length > 0 &&
        this.validaEhEditavel(
          this.periodoAvaliacaoAnoAtual.dataInicioLancamento,
          this.periodoAvaliacaoAnoAtual.dataFimLancamento,
        )
      );
    },
    ehAvaliador() {
      return this.avaliador ? this.avaliador.totalPendente != null : false;
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
  },
  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.editaRegistro(this.funcionario.id);
    },
  },
  methods: {
    statusDaLinhaDaTabela(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];
      const { totalAutoavaliacao } = this.avaliacaoAtualDoAvaliado;

      return this.validaEhEditavel(dataInicioLancamento, dataFimLancamento) &&
        totalAutoavaliacao === 0
        ? 'situacao-pendente'
        : '';
    },
    statusDaAvaliacao(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];
      const { naoExiste } = this.avaliacaoAtualDoAvaliado;

      const ehEditavel = this.validaEhEditavel(
        dataInicioLancamento,
        dataFimLancamento,
      );
      const avaliacaoNaoExiste = ehEditavel && naoExiste;
      const periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);

      if (ehEditavel) return 'EM ANDAMENTO';
      if (avaliacaoNaoExiste) return 'SEM AUTOAVALIAÇÃO';
      if (periodoAindaNaoAbriu) return 'INDISPONÍVEL';
      return 'FINALIZADA';
    },
    quantidadeDeAvaliacoesPorAvaliador(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];

      return this.situacaoAvaliacoesPendentes(
        dataInicioLancamento,
        dataFimLancamento,
        this.avaliador,
      )
        ? this.avaliador.totalPendente
        : 'NENHUM';
    },
    statusDoBotao(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];
      const { totalAutoavaliacao } = this.avaliacaoAtualDoAvaliado;

      return this.validaEhEditavel(dataInicioLancamento, dataFimLancamento) &&
        totalAutoavaliacao === 0
        ? 'vazado-laranja-sm'
        : 'vazado-cinza-sm';
    },
    condicionalDoBotaoDeAvaliador(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];

      return this.validaEhEditavel(dataInicioLancamento, dataFimLancamento);
    },
    condicionalDoBotaoComum(avaliacao, status) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];
      const { aceita, mediaEstagioProbatorio } = this.avaliacaoAtualDoAvaliado;

      const ehEditavel = this.validaEhEditavel(
        dataInicioLancamento,
        dataFimLancamento,
      );

      if (status) {
        return ehEditavel;
      }

      return !ehEditavel;
    },
    validaEhEditavel(dataInicial, dataFinal) {
      const { aceita, mediaEstagioProbatorio } = this.avaliacaoAtualDoAvaliado;

      if (dataInicial && dataFinal) {
        return (
          PeriodoAtualHelper.validaPeriodo(dataInicial, dataFinal) &&
          aceita === null &&
          mediaEstagioProbatorio === 0
        );
      }
      return false;
    },
    validaPeriodoAindaNaoAbriu(avaliacao) {
      const { dataInicioLancamento } = avaliacao.periodos[0];

      const periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);

      if (periodoAindaNaoAbriu) {
        const erro = new Error('O período de avaliação ainda não está aberto');
        erro.type = 'warning';
        throw erro;
      }
    },
    situacaoAvaliacoesPendentes(dataInicial, dataFinal, avaliador) {
      if (dataInicial && dataFinal && avaliador) {
        return (
          PeriodoAtualHelper.validaPeriodo(dataInicial, dataFinal) &&
          avaliador.totalPendente > 0
        );
      }
      return false;
    },
    apagaDuplicatas(array) {
      let arrayLimpo = [];
      array.forEach(element => {
        if (!arrayLimpo.some(item => item.id === element.id)) {
          arrayLimpo.push(element);
        }
      });

      return arrayLimpo;
    },
    async editaRegistro(funcionarioId) {
      this.carregando = true;
      try {
        const anosAvaliados = await AvaliacoesService.lista(funcionarioId);

        if (!anosAvaliados.length) {
          this.anosAvaliados = anosAvaliados;
          this.carregando = false;
          return;
        }
        this.anosAvaliados = this.apagaDuplicatas(anosAvaliados);
        this.periodoAvaliacaoAnoAtual = this.avaliacoesOrdenadas[0];
        this.obtemUltimaAvaliacaoDoLogado(
          funcionarioId,
          this.periodoAvaliacaoAnoAtual.id,
        );
        this.obtemContagemAvaliados(
          funcionarioId,
          this.periodoAvaliacaoAnoAtual.id,
        );
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
    async obtemUltimaAvaliacaoDoLogado(funcionarioId, idMes) {
      try {
        const avaliacao = await PeriodosService.obtemDoFuncionario(
          funcionarioId,
          idMes,
        );
        if (!avaliacao.length) {
          this.avaliacaoAtualDoAvaliado = {
            totalAutoavaliacao: 100,
            mediaEstagioProbatorio: 0,
            aceita: true,
            naoExiste: true,
          };
          return;
        }
        this.avaliacaoAtualDoAvaliado = avaliacao[0];
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async obtemContagemAvaliados(funcionarioId, idMes) {
      this.carregando = true;

      try {
        const avaliador = await AvaliadorService.lista(funcionarioId, idMes);
        this.avaliador = avaliador;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Recurso não encontrado') {
          this.avaliador.totalPendente = null;
          return;
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
    async editaAvaliacao(id, avaliacao) {
      try {
        this.validaPeriodoAindaNaoAbriu(avaliacao);

        const periodos = await PeriodosService.lista(id, avaliacao.id);
        this.periodos = periodos;
        sessionStorage.setItem('periodos', JSON.stringify(this.periodos));
        if (
          this.periodos.length === 1 &&
          !this.avaliacaoAtualDoAvaliado.naoExiste
        ) {
          this.$router.push({
            name: 'DetalhaAvaliacao',
            params: {
              idAvaliador: this.funcionario.id,
              idAvaliado: id,
            },
          });

          return;
        }

        this.$router.push({
          name: 'Avaliados',
          params: { idAvaliador: this.funcionario.id },
        });
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);

        if (error.type === 'warning') {
          this.$root.$refs.toastr.w(mensagem, 'Atenção');
          return;
        }

        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
  },
  created() {
    this.editaRegistro(this.funcionario.id);
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {
    Botao,
    CardHeader,
    TableLoader,
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?6ed3943b